import React from "react";
import Icon from "./Icon";

export function InfoCard({ title, icon = "info", children }) {
  return (
    <div className="info-card">
      <div className="info-card-header">
        <span className="info-card-icon" aria-hidden="true">
          <Icon name={icon} size={20} />
        </span>
        <span>{title}</span>
      </div>
      <div>{children}</div>
    </div>
  );
}

export default InfoCard;
